<template>
    <div>
        <label class="field_label">{{ current_champ.label }}<span class="text-red"
                v-if="current_champ.mandatory == 1">*</span></label>
        <div class="d-flex align-stretch">

            <v-text-field ref="birthday_day_field" hide-details @input="onChangeDayField" @blur="onBlurDayField"
                label="Jour" type="number" placeholder="JJ" v-model="readable_date.day" min="1" max="31"></v-text-field>
            <v-text-field ref="birthday_month_field" hide-details @input="onChangeMonthField" @blur="onBlurMonthField"
                label="Mois" type="number" placeholder="MM" v-model="readable_date.month" min="1"
                max="12"></v-text-field>
            <v-text-field ref="birthday_year_field" placeholder="AAAA" hide-details @input="onChangeYearField"
                label="Année" type="number" v-model="readable_date.year" min="1900" max="2100"
                :disabled="year_not_editable"></v-text-field>
        </div>
        <div v-if="year_not_editable">L'année de naissance n'est pas modifiable</div>


        <v-text-field class="real_birthdate_field" type="text" v-model="current_champ.value"
            @change="change_identity_current_coureur(current_champ.nom)" ref="field" @blur="$refs.field.validate()"
            :disabled="current_champ.disabled || is_disable"
            :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-text-field>


    </div>
</template>

<script>


export default {
    props: ["champ", "inscription", "mode", "is_disable", "disable_year"],
    data() {
        return {
            current_champ: {},
            readable_date: {
                day: "",
                month: "",
                year: "",
            },
        };
    },

    watch: {
        champ: {
            deep: true,
            handler() {
                this.current_champ = this.champ;
                if (this.current_champ.value != '') {
                    let date = this.current_champ.value.split('-');
                    this.readable_date.day = date[2];
                    this.readable_date.month = date[1];
                    this.readable_date.year = date[0];
                }

                this.$forceUpdate();


            },
        },
        readable_date: {
            deep: true,
            handler() {
                this.update_field_value();
            },
        },

    },
    computed: {
        year_not_editable() {
            return this.disable_year && this.disable_year == 1;
        }
    },
    methods: {

        onBlurDayField() {
            if (this.readable_date.day.length == 1 && this.readable_date.day != '0') {
                this.readable_date.day = '0' + this.readable_date.day;
            }
        },
        onBlurMonthField() {
            if (this.readable_date.month.length == 1 && this.readable_date.month != '0') {
                this.readable_date.month = '0' + this.readable_date.month;
            }
        },
        onChangeDayField() {
            if (this.readable_date.day.length == 2) {
                this.$refs.birthday_day_field.blur();
                this.$refs.birthday_month_field.focus();
            }
        },
        onChangeMonthField() {

            if (this.readable_date.month.length == 2) {
                this.$refs.birthday_month_field.blur();
                this.$refs.birthday_year_field.focus();
            }
        },
        onChangeYearField() {

            if (this.readable_date.year.length == 4) {
                this.$refs.birthday_year_field.blur();
            }
        },
        update_field_value() {
            const day = this.readable_date.day;
            const month = this.readable_date.month;
            const year = this.readable_date.year;


            if (parseInt(day) > 0 && parseInt(day) < 32 && parseInt(month) > 0 && parseInt(month) < 13 && parseInt(year) > 1900 && parseInt(year) < 2100) {
                let computed_date = this.readable_date.year + '-' + this.readable_date.month + '-' + this.readable_date.day;
                this.current_champ.value = computed_date;
            }
            else {
                this.current_champ.value = '';
            }


        }
    },


    created() {
        this.current_champ = this.champ;
        if (this.current_champ.value != '') {
            let date = this.current_champ.value.split('-');
            this.readable_date.day = date[2];
            this.readable_date.month = date[1];
            this.readable_date.year = date[0];
        }
        else if (this.current_champ.value == '') {
            this.readable_date.day = '';
            this.readable_date.month = '';
            this.readable_date.year = '';
        }

    },
};
</script>

<style lang="scss">
.real_birthdate_field input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
.real_birthdate_field input[type=number] {
    -moz-appearance: textfield;
}

.real_birthdate_field .v-field__field {
    display: none;
}

.real_birthdate_field .v-field:not(.v-field--error) .v-field__outline {
    display: none;
}

.slash_sep_date {
    background-color: #f6f6f6;
    border-bottom: 1px solid rgba(118, 118, 118, .5);
}
</style>